module.exports = __webpack_public_path__ + "assets/images/pressure_r.2ff868b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/pressure_r.png
// module id = 759
// module chunks = 1